import { useQuery } from '@tanstack/react-query'
import { getTaskStatuses } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

/**
 * タスクステータス一覧取得フック
 */
export function useTaskStatuses() {
  return useQuery({
    queryKey: queryKeys.taskStatuses,
    queryFn: async () => {
      return getTaskStatuses()
    },
    staleTime: Number.POSITIVE_INFINITY, // マスターデータなので永遠にキャッシュ
  })
}
